import { render, staticRenderFns } from "./DashboardVentasPerdidos.vue?vue&type=template&id=92388ade&scoped=true&lang=pug"
import script from "./DashboardVentasPerdidos.vue?vue&type=script&lang=js"
export * from "./DashboardVentasPerdidos.vue?vue&type=script&lang=js"
import style0 from "./DashboardVentasPerdidos.vue?vue&type=style&index=0&id=92388ade&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92388ade",
  null
  
)

export default component.exports